<template>
  <div class="videos">
    <div class="section">
      <div>
        <BreadCreamVue :data="BreadCreamData" />
      </div>
      <ul class="flex-row no-padding justify-start videos-list flex-wrap">
        <div class="flex-row flex-wrap space-x-30">
          <div class="video-item" v-for="it in vl" :key="it.id">
            <router-link :to="`/videos/${it.id}`">
              <div class="video-origin">
                <video :src="it.url" controls  :poster="it.poster"></video>
                <div class="hover-masker flex items-center  justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="white">
                    <path d="M12 4.5C7.305 4.5 3.29 7.262 1 12c2.29 4.738 6.305 7.5 11 7.5s8.71-2.762 11-7.5c-2.29-4.738-6.305-7.5-11-7.5zm0 13a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11z"/>
                  </svg>
                  查看
                </div>
              </div>
              <div class="video-title" v-text="it.title"></div>
            </router-link>
          </div>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
import { defineComponent, watch, computed } from "@vue/composition-api";
import BreadCreamVue from "../../components/BreadCream.vue";
import { api } from "../../utils/apis";
import { useFetchList } from "../../hooks/fetch-list";
import { vlist } from "./index";
export default defineComponent({
  name: "Videos",
  components: {
    BreadCreamVue,
  },
  setup(props, ctx) {
    const BreadCreamData = [
      {
        title: "VIDEOS",
        to: "/videos",
      },
      {
        title: "LIST",
        to: "",
      },
    ];

    const vl = computed(() => vlist)

    const { data, count, handlePageChange, query, isLoading } = useFetchList({
      api: api.research.list,
      initQuery: { page_size: 20, page: 1 },
      ctx,
    });

    watch(
      () => data.value,
      () => {
        // 跳转地址是news/${id}
        data.value && data.value.forEach((it) => (it.to = "/research"));
      }
    );

    return { query, data, count, BreadCreamData, handlePageChange, isLoading, vl };
  },
});
</script>
<style lang="scss" scoped>
.videos {
  .space-x-30 {
    gap: 30px;
  }

  .video-item {
    flex: 0 0 290px;
    margin-top: 30px;
    border-radius: 5px;
  }

  .video-title {
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 18px;
    font-weight: 600;
    color: #ffffff;
    line-height: 52px;
    border-radius: 5px;
    text-align: center;
    font-weight: 600;
    color: #423e3d;
    line-height: 28px;
    margin: 20px 20px 0;
    // font-family: "SimHei", Arial, Helvetica, sans-serif;
  }

  .video-origin {
    width: 290px;
    display: block;
    transition: all 0.2s;
    border-radius: 5px;
    position: relative;
    .hover-masker{
      opacity: 0;
      background-color: rgba($color: #000000, $alpha: 1.0);
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      color:#FFF;
      text-align: center;
      gap:10px;
      text-align: center;
    }
    &:hover {
      box-shadow: 0px 0px 20px 0px rgba(81, 85, 106, 0.36);
      .hover-masker{
        opacity: 0.8;
      }
    }
    video{
      width: 100%;
      height: 100%;
      display: block;
    }
    
  }
}
</style>
